import * as TYPE from "../types";
const initialState = {
  campaigns: [],
  sources: [],
  mediums: [],
};
export const utmListReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.UTM_LIST_FOUND:
      return {
        ...action.payload,
        msg: "Utm List found",
      };
    case TYPE.UTM_LIST_NOT_FOUND:
      return {
        ...initialState,
        msg: "Utm List not found",
      };
    case TYPE.UTM_LIST_ERROR:
      return {
        ...initialState,
        msg: "OOPS! Something went wrong!",
      };
    default:
      return state;
  }
};
